import IconSvg from './icon-svg';

export default IconSvg;
